<template>
  <div id="SystemRequirements">
    <b-form class="padding">
      <b-row>
        <b-col></b-col>
        <b-col cols="8">
          <b-card class="card-border">
            <b-card-title style="text-align: center"><h3>{{$t('msg.system_requirements')}}</h3></b-card-title>
            <b-card-body>
              <div>
                <b-row>
                  <b-col class="text-justify padding-border" cols="12">
                    <p>
                      {{$t('msg.system_requirements_header_text')}}
                    </p>
                    <b-table striped outlined bordered :items="items" :fields="fields"></b-table>
                  </b-col>
                </b-row>
              </div>
              <br>
            </b-card-body>
            <div style="text-align: center; margin-top: -4.5%; padding: 1%">
              <b-button variant="primary" href="/">{{$t('msg.back_to_login')}}</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { i18n } from '@/main'

export default {
  name: 'SystemRequirements',
  data () {
    return {
      // Note `isActive` is left out and will not appear in the rendered table
      fields: [i18n.t('msg.requirements'), i18n.t('msg.supported')],
      items: [
        { [i18n.t('msg.requirements')]: i18n.t('msg.web_browser'), [i18n.t('msg.supported')]: i18n.t('msg.supported_latest_version') },
        { [i18n.t('msg.requirements')]: i18n.t('msg.javascript'), [i18n.t('msg.supported')]: i18n.t('msg.supported_javascript') },
        { [i18n.t('msg.requirements')]: i18n.t('msg.cookies'), [i18n.t('msg.supported')]: i18n.t('msg.supported_cookies') },
        { [i18n.t('msg.requirements')]: i18n.t('msg.screen_resolution'), [i18n.t('msg.supported')]: i18n.t('msg.supported_screen_resolution') }
      ]
    }
  }
}
</script>

<style scoped>
.padding {
  padding: 2%;
}

.padding-border {
  padding: 2%;
}

.card-border {
  box-shadow: 1px 2px 10px -1px;
  background: rgba(255, 255, 255, .75);
}
</style>
